/* eslint react/no-multi-comp: 0, react/prop-types: 0 */
// eslint-disable-next-line
import React, { useState, useEffect } from 'react';
import { Row, Col, Button, Modal, ModalHeader, ModalBody, ModalFooter, Form } from 'react-bootstrap';
import FormGroupInput from '../common/FormGroupInput'; // eslint-disable-next-line
import { copiriAxiosPost, copiriPortalRequest, copiriAxiosGet, checkValidation } from '../api/api'; // eslint-disable-next-line
import config from '../config/config'; // eslint-disable-next-line
import { toast } from 'react-toastify'; // eslint-disable-next-line
import { enc } from '../../gibberish-aes';
import { genPageData } from '../langconfig/langconfig'; // eslint-disable-next-line
const AddEditProfilePhoneModal = props => {
	// eslint-disable-next-line
	const { data, type, inputField, setInputField, pageLanguageContent } = props;
	const [dialCodes, setDialCodes] = useState([]);
	const [validation, setValidation] = useState({
		error_phone: '',
		error_dial: ''
	});
	const [disableSubmitButton, setDisableSubmitButton] = useState(false);
	useEffect(() => {
		if (props.showHide) {
			if (type === 'edit_phone') {
				const { phone } = data;
				setInputField({ ...inputField, phone });
			} else {
				let phone = '';
				setInputField({ ...inputField, phone });
			}
			getDailCode();
		}
		// eslint-disable-next-line
	}, [props.showHide]);

	function getDailCode() {
		copiriPortalRequest('/canon/dialcodes', config.app_version, 'get')
			.then(response => {
				if (response.data.length > 0) {
					setDialCodes(response.data);
				}
			})
			.catch(error => {});
	}

	const inputsHandler = e => {
		setInputField({ ...inputField, [e.target.name]: e.target.value });
	};

	function updatePhoneData() {
		let errors = { ...validation };
		var errorCount = 0;

		if (!inputField.phone.trim()) {
			errors.error_phone = pageLanguageContent['PRL026'];
			errorCount++;
		} else if (!checkValidation(inputField.phone, 'phone')) {
			errors.error_phone = pageLanguageContent['PRL142'];
			errorCount++;
		} else {
			errors.error_phone = '';
		}

		if (!inputField.dial.trim()) {
			errors.error_dial = pageLanguageContent['PRL026'];
			errorCount++;
		} else {
			errors.error_dial = '';
		}
		setValidation(errors);
		if (errorCount <= 0) {
			setDisableSubmitButton(true);
			var sendFormData = {};
			sendFormData['phone_num'] = inputField['phone'];
			sendFormData['phone_code_id'] = parseInt(inputField['dial']);
			let d_code = '';
			for (let i = 0; i < dialCodes.length; i++) {
				if (dialCodes[i]['id'] === parseInt(inputField['dial'])) {
					d_code = dialCodes[i]['dialcode'];
				}
			}
			copiriPortalRequest('/users/' + data['id'], config.app_version, 'patch', sendFormData)
				.then(response => {
					setDisableSubmitButton(false);
					if (response.status && response.status === 200) {
						toast.success(genPageData['GENDUS'] ? genPageData['GENDUS'] : '');
						props.onClick();
						props.updateModal(type, data['id'], inputField);
						document.getElementById('user_phone_no').innerHTML = '+' + d_code + ' ' + inputField['phone'];
					}
				})
				.catch(error => {
					setDisableSubmitButton(false);
					toast.error(error?.response?.data?.result);
				});
		}
	}

	return (
		<>
			<Modal show={props.showHide} onHide={props.onClick} className='email_modal'>
				<ModalHeader
					onHide={props.onClick}
					style={{ backgroundColor: '#337ab7', border: '#337ab7' }}
					className='modalHeader'
				>
					<Modal.Title>
						{type && type === 'edit'
							? pageLanguageContent['PRL114']
								? pageLanguageContent['PRL114']
								: ''
							: pageLanguageContent['PRL113']
							? pageLanguageContent['PRL113']
							: ''}
					</Modal.Title>
				</ModalHeader>
				<ModalBody>
					<Row>
						<Col lg={4}>
							<Form.Group className='form-group'>
								<Form.Label for='dial'>{pageLanguageContent['PRL115'] ? pageLanguageContent['PRL115'] : ''}</Form.Label>
								<select
									id='dial'
									label={pageLanguageContent['PRL116'] ? pageLanguageContent['PRL116'] : ''}
									type='text'
									onChange={inputsHandler}
									value={inputField.dial}
									name='dial'
									className='form-control'
								>
									<option value={''}>{pageLanguageContent['PRL100'] ? pageLanguageContent['PRL100'] : ''}</option>
									{dialCodes.length > 0 &&
										dialCodes.map((item, i) => (
											<option value={item.id} key={i}>
												(+{item?.dialcode}) {item.name}
											</option>
										))}
								</select>
							</Form.Group>
							{validation.error_dial && <p className='formValidationError'>{validation.error_dial}</p>}
						</Col>

						<Col lg={8}>
							<FormGroupInput
								id='phone'
								label={pageLanguageContent['PRL117'] ? pageLanguageContent['PRL117'] : ''}
								type='text'
								onChange={inputsHandler}
								value={inputField.phone}
								name='phone'
							/>
							{validation.error_phone && <p className='formValidationError'>{validation.error_phone}</p>}
						</Col>
					</Row>
				</ModalBody>
				<ModalFooter>
					<Button color='primary' onClick={updatePhoneData} disabled={disableSubmitButton}>
						{genPageData['GENSAV'] ? genPageData['GENSAV'] : ''}
					</Button>
				</ModalFooter>
			</Modal>
		</>
	);
};
export default AddEditProfilePhoneModal;
